import { Link, useLocation } from 'react-router-dom';
import { LockKeyhole } from 'lucide-react';
import { useModuleAccess } from '@/contexts/ModuleAccessContext';
import { modulesForPath } from '@/lib/module-access';
import { Button } from './Button';
import { RouteSkeleton } from './PageSkeletons';

export function ModulePageGuard({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const { loading, error, has, refresh } = useModuleAccess();
  const required = modulesForPath(pathname);
  if (!required.length) return <>{children}</>;
  if (loading) return <RouteSkeleton pathname={pathname} />;
  if (error || required.some(alternatives => !alternatives.some(has))) return <div className="m-6 rounded-2xl border border-border bg-surface p-6"><LockKeyhole className="mb-4 text-primary" size={28} /><h1 className="text-lg font-semibold">{error ? 'Workspace access could not be loaded' : 'This module is not enabled'}</h1><p className="mt-2 text-sm text-text-muted">{error ? 'Retry to load the modules assigned to your company.' : 'Your administrator can enable this module for your company.'}</p><div className="mt-5 flex items-center gap-4"><Button variant="secondary" onClick={refresh}>Refresh access</Button><Link to="/settings" className="text-sm text-primary">Account settings</Link></div></div>;
  return <>{children}</>;
}
